import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ed3ff764&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=ed3ff764&prod&lang=scss&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=ed3ff764&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3ff764",
  null
  
)

export default component.exports